import React from 'react'
import logo from '../../../assets/static/logo-ttlGrande.png'

const LogotipoTTL = () => (
	<img className="logotipo-ttl" 
	src={logo}
	alt="Logotipo TTL"
	height="30px"
	width = "130px" />
)

export default LogotipoTTL
